<template>
  <div style="width: 100%">
    <button
      class="flex-button"
      :class="['atc-add-button', { 'inline-atc-add-button': !isFullScreen }]"
      @click="addToCart(ctaAction)"
      :disabled="isOutOfStock"
      :style="atcAddButtonStyle"
    >
      <shopping-bag
        :class="{ 'inline-icon': !isFullScreen }"
        ref="icon"
      ></shopping-bag>

      <span class="atc-add-button__text" :style="`color: ${secondaryColor}`"
        >{{ this.$t(`${buttonText}`) }}
      </span>
    </button>
  </div>
</template>

<script>
import ShoppingBag from "@/assets/shopping-bag.svg";
import { mapGetters } from "vuex";
import enums from "@/enums.js";
const { ctaActions } = enums;



export default {
  components: {
    ShoppingBag,
  },
  props: {
    colors: {
      type: Object,
      default: () => {
        return { primaryColor: "#ffffff", secondaryColor: "#000000" };
      },
    },
    additionalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    variantId: {
      type: [String, Number],
      default: null,
    },
    vidjetProductId: {
      type: String,
      default: "",
    },
    pluginProductId: {
      type: [String, Number],
      default: "",
    },
    isOutOfStock: {
      type: Boolean,
      default: true,
    },
    isManucurist: {
      type: Boolean,
      default: false,
    },
    isFullScreen: {
      type: Boolean,
      default: false,
    },
    isQuickShop: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    this.$refs.icon.setAttribute("fill", this.secondaryColor);
  },

  watch: {
    secondaryColor() {
      this.$refs.icon.setAttribute("fill", this.secondaryColor);
    },
  },

  computed: {
    ...mapGetters("playerCampaign", ["format"]),
    ...mapGetters("playerSite", ["site"]),
    primaryColor() {
      if (this.colors.primaryColor === this.colors.secondaryColor)
        return "#000000";
      return this.colors.primaryColor;
    },
    secondaryColor() {
      if (this.colors.primaryColor === this.colors.secondaryColor)
        return "#ffffff";
      return this.colors.secondaryColor;
    },
    buttonText() {
      //They want a different text for the client Je taime Paris
      if (this.$route.params.siteId === 'f98b3ab0-0273-4608-a7c7-842e66a421bf') return 'Je personnalise';

      if (this.isQuickShop) {
        return this.format?.quickShop?.ctaAction === ctaActions.addtoCart
          ? "player.atcFormAddButton.addToCart"
          : "player.atcFormAddButton.buyNow";
      }
      return this.format?.cta?.ctaAction === ctaActions.addtoCart
        ? "player.atcFormAddButton.addToCart"
        : "player.atcFormAddButton.buyNow";
    },
    ctaAction() {
      if (this.isQuickShop) {
        return this.format?.quickShop?.ctaAction;
      }
      return this.format?.cta?.ctaAction || ctaActions.buyNow;
    },
    atcAddButtonStyle() {
      const style = {
        border: `2px solid ${this.colors.primaryColor}`,
        background: this.colors.primaryColor,
        color: this.secondaryColor,
      };

      //For belevels round corners
      if (this.site._id === "62526c52-c1c6-4146-8dfa-0b02922189ca") {
        style.borderRadius = "16px";
      }
      if (this.format.productCardElementsStyle === "round") {
        style.borderRadius = "16px"
      } else if (this.format.productCardElementsStyle === "semi") {
        style.borderRadius = "8px"
      } else if (this.format.productCardElementsStyle === "square") {
        style.borderRadius = "2px"
      }

      return style;
    },
  },

  methods: {
    addToCart(ctaAction) {
      const dataToSend = {
        messageOrigin: "vidjet",
        origin: "addToCart",
        properties: {
          productId: this.pluginProductId,
          variantId: this.variantId,
        },
      };
      if (Object.keys(this.additionalData).length > 0) {
        this.additionalData.properties.id = this.variantId;
        dataToSend.properties = {
          ...dataToSend.properties,
          ...this.additionalData,
        };
      }

      if (ctaAction === ctaActions.buyNow) {
        dataToSend.properties.isBuyNow = true;
      }

      window.parent.postMessage(dataToSend, "*");

      ctaAction === ctaActions.buyNow
        ? this.$emit("buy-now-clicked", {
            variantId: this.variantId,
            vidjetProductId: this.vidjetProductId,
            quantity: 1,
          })
        : this.$emit("added-to-cart", this.vidjetProductId);
    },
  },
};
</script>

<style lang="scss" scoped>
.atc-add-button {
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 8px 0;
  background: white;
  transition: 0.4s ease box-shadow, 0.4s ease transform;
  border-radius: 3px;
  font-size: 16px;
  font-weight: 600;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
  margin: 0 auto;

  &:hover {
    box-shadow: none;
    transform: translateX(2px) translateY(2px);
  }

  &:disabled {
    background: grey;
    transform: translateX(2px) translateY(2px);
    cursor: not-allowed;
  }
}

.isFullScreen .atc-add-button {
  max-width: 100%;
}

.is-in-preview {
  width: 150px;
}

.flex-button {
  display: flex;
  gap: 4px;
  align-items: center;
}
.inline-atc-add-button {
  font-size: 14px;
}
.inline-icon {
  transform: scale(80%);
}
</style>
